import API from "@aws-amplify/api";
import Auth from "@aws-amplify/auth";

const APINAME = "AdminQueries";
const getAuth = async () =>
  `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`;
async function createUser(username: string) {
  let props = {
    body: {
      username,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return API.post(APINAME, "/createUser", props);
}

async function setUserPassword(username: string, password: string) {
  let props = {
    body: {
      username,
      password,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return API.post(APINAME, "/setPassword", props);
}

async function enableUser(username: string) {
  let props = {
    body: {
      username,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return await API.post(APINAME, "/enableUser", props);
}
async function disableUser(username: string) {
  let props = {
    body: {
      username,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return await API.post(APINAME, "/disableUser", props);
}
async function addUserToGroup(username: string, groupname: string) {
  let props = {
    body: {
      username,
      groupname,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return await API.post(APINAME, "/addUserToGroup", props);
}

async function removeUserFromGroup(username: string, groupname: string) {
  let props = {
    body: {
      username,
      groupname,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: await getAuth(),
    },
  };
  return await API.post(APINAME, "/removeUserFromGroup", props);
}
export {
  enableUser,
  disableUser,
  createUser,
  addUserToGroup,
  removeUserFromGroup,setUserPassword
};
